import { AlertService } from 'app/services/alert.service';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { Router } from '@angular/router';
import { Garantia } from 'app/models/Garantia';
import { MessagesTitles, MessagesGeneral, MessagesDates } from 'app/models/messages';
import { LoginService } from 'app/services/login/login.service';
import { RiesgoService } from 'app/services/riesgo/riesgo.service';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { ACCION_GARANTIA } from '../../../../models/UtilGestionFondo';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "YYYY"
  }
};

@Component({
  selector: 'app-nueva-garantia',
  templateUrl: './nueva-garantia.component.html',
  styleUrls: ['./nueva-garantia.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesDates,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class NuevaGarantiaComponent implements OnInit, OnDestroy {
  garantia: Garantia;
  flagVer: boolean = null;
  flagCrear: boolean = null;
  flagEditar: boolean = null;
  loadingGarantias: boolean = false;
  loadingLineas: boolean = false;
  loadingLineasError: boolean = false;
  readonly CANAL_AUDITORIA: string = 'W';
  tituloFormGarantia: string = '';
  userActive: any;
  tiposMoneda: any[] = [];
  tiposLineaGarantia: any[] = [];
  lineasGarantia: any[] = [];
  lineasGarantiaTemp: any[] = [];
  IP: string = '';
  fechaActual: string;
  primerFormGroup: FormGroup;
  segundoFormGroup: FormGroup;
  formGarantia: FormGroup;
  textQuestionSwal: string;
  textConfirmSwal: string;
  textErrorSwal: string;
  nuevoFinanciamiento: boolean;
  sumPorcentajeValido: boolean = true;
  sumMontoValido: boolean = true;
  arrLineasGarantiaTemp: FormArray;
  minDate: Date = new Date();

  subLista: Subscription[] = [];
  subGarantias: Subscription = new Subscription();
  subLineaGarantia: Subscription = new Subscription();
  subFinanciamientos: Subscription = new Subscription();

  constructor(
    private datePipe: DatePipe,
    private formBuilder: FormBuilder,
    private riesgoService: RiesgoService,
    private router: Router,
    private loginService: LoginService,
    private alertService: AlertService
  ) {
    this.garantia = this.riesgoService.dataGarantia;
    this.flagCrear = this.riesgoService.flagCrear;
    this.flagEditar = this.riesgoService.flagEditar;
    this.flagVer = this.riesgoService.flagVer;

    if (this.flagCrear == null || this.flagEditar == null || this.flagVer == null) {
      this.router.navigate(['/fondo/concentracion/garantias/listado']);
    }

    this.fechaActual = new Date().toISOString().split('T')[0];
    this.userActive = JSON.parse(sessionStorage.getItem('UserActive'));
    this.IP = JSON.parse(sessionStorage.getItem('PUBLIC-IP')).ip ? JSON.parse(sessionStorage.getItem('PUBLIC-IP')).ip : '192.168.1.1';
    this.tiposMoneda = this.riesgoService.Monedas;
    this.tiposLineaGarantia = this.riesgoService.TiposLineaGarantia;
  }

  ngOnInit() {
    this.tiposMoneda.forEach(moneda => moneda.value = (moneda.key === '') ? 'Seleccione una moneda' : moneda.value);
    this.primerFormGroup = this.formBuilder.group({
      idGarantia: '',
      Nombre_Garantia: ['', [Validators.required, Validators.maxLength(30)]],
      Codigo_Garantia: ['', [Validators.required, Validators.maxLength(45)]],
      Moneda: ['', [Validators.required]],
      MonedaDsc: '',
      Multiples_Moneda: false,
      Fecha_Inicio: new Date(),
      Fecha_Fin: null,
      Estado: ['A', [Validators.required]],
      EstadoGarantiaDsc: 'ACTIVO'
    });

    this.segundoFormGroup = this.formBuilder.group({
      Tipo: '',
      Monto_Cobertura_Maxima: [{ value: null, disabled: (this.flagEditar || this.flagVer) }, [Validators.required, Validators.pattern(/^\d*\.?\d{0,2}$/), Validators.min(0.01), Validators.max(999999999.99)]],
      Monto_Cobertura_Disponible: [{ value: null, disabled: true }, [Validators.required, Validators.pattern(/^\d*\.?\d{0,2}$/), Validators.min(0.01), Validators.max(999999999.99)]],
      Monto_Cobertura_Ejecutado: [{ value: null, disabled: true }, [Validators.required, Validators.pattern(/^\d*\.?\d{0,2}$/), Validators.max(999999999.99)]],
      Monto_Cobertura_Bloqueado: [{ value: null, disabled: true }, [Validators.required, Validators.pattern(/^\d*\.?\d{0,2}$/), Validators.max(999999999.99)]],
      lineas_garantia: this.formBuilder.array([])
    });

    this.formGarantia = this.formBuilder.group({
      idGarantia: null,
      Nombre_Garantia: '',
      Codigo_Garantia: '',
      Moneda: '',
      Multiples_Moneda: '',
      Fecha_Inicio: '',
      Fecha_Fin: '',
      Estado: '',
      Monto_Cobertura_Maxima: '',
      Monto_Cobertura_Disponible: '',
      Monto_Cobertura_Ejecutado: '',
      Monto_Cobertura_Bloqueado: '',
      lineas_garantia: this.groupLineas,
      AltaFecha: '',
      AltaCanal: this.CANAL_AUDITORIA,
      Usuario: this.userActive.Usuario,
      ModificacionUsuario: '',
      ModificacionFecha: '',
      ModificacionCanal: '',
      IP: this.IP
    });

    if (this.flagCrear) {
      this.tituloFormGarantia = 'Crear garantía';
    } else if (this.flagEditar) {
      this.tituloFormGarantia = 'Modificar datos de la garantía N° '.concat(this.garantia.idGarantia.toString());
      this.obtenerData();
      this.obtenerLineaGarantia();
    } else if (this.flagVer) {
      this.tituloFormGarantia = 'Detalle de la garantía N° '.concat(this.garantia.idGarantia.toString());
      this.obtenerData();
      this.obtenerLineaGarantia();

      this.primerFormGroup.disable();
      this.segundoFormGroup.disable();
    }
  }

  ngOnDestroy() {
    this.subLista.forEach(sub => { sub.unsubscribe() });
  }

  /**
  * Función para obtener datos del garantia y asignarlos a los formularios correspondientes (actualizar, ver).
  */
  obtenerData() {
    let estadoDsc: string = '';
    if (this.garantia.Estado == 'A') {
      estadoDsc = 'Activo';
    } else {
      estadoDsc = 'Inactivo';
    }

    this.primerFormGroup.patchValue({
      IdFondo: this.garantia.idGarantia,
      Nombre_Garantia: this.garantia.Nombre_Garantia,
      Codigo_Garantia: this.garantia.Codigo_Garantia,
      Moneda: this.garantia.Moneda.toString(),
      MonedaDsc: this.garantia.Moneda_Descripcion,
      Multiples_Moneda: (this.garantia.Multiples_Moneda == 'A') ? true : false,
      Fecha_Inicio: this.garantia.Fecha_Inicio ? this.garantia.Fecha_Inicio : null,
      Fecha_Fin: this.garantia.Fecha_Fin ? this.garantia.Fecha_Fin : null,
      Estado: this.garantia.Estado,
      EstadoFondoDsc: estadoDsc
    });

    this.segundoFormGroup.patchValue({
      Tipo: '',
      Monto_Cobertura_Maxima: this.garantia.Monto_Cobertura_Maxima,
      Monto_Cobertura_Disponible: this.garantia.Monto_Cobertura_Disponible,
      Monto_Cobertura_Ejecutado: this.garantia.Monto_Cobertura_Ejecutado,
      Monto_Cobertura_Bloqueado: this.garantia.Monto_Cobertura_Bloqueado
    });
  }

  /**
  * Función para obtener lineas de garantía (crear) o por id garantía (ver). --  AÚN NO EXISTE
  */
  obtenerLineaGarantia() {
    this.loadingLineas = true;
    this.subLineaGarantia = this.riesgoService.obtenerLineasGarantia().subscribe(
      (resLineaGarantia: any[]) => {
        this.lineasGarantia = resLineaGarantia;
        this.lineasGarantia.forEach(element => {
          if (element.idGarantia == this.garantia.idGarantia) {
            element.nuevo = false;
            this.lineasGarantiaTemp.push(element);
          }
        });
        this.loadingLineas = false;
        if (this.flagEditar || this.flagVer) {
          this.asignarLineas(this.lineasGarantiaTemp);
        }

      },
      (err: HttpErrorResponse) => {
        this.loadingLineas = false;
        this.loadingLineasError = true;
        this.lineasGarantia = [];
        Swal.fire({
          title: 'Error',
          html: this.alertService.createTextError(err, 'Linea garantía no obtenida. <br/>'),
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });
      }
    );

    this.subLista.push(this.subLineaGarantia);
  }

  /**
  * Función para obtener las lineas secundarias de la garantía del formulario.
  */
  get groupLineas() {
    return this.segundoFormGroup.get('lineas_garantia') as FormArray;
  }

  /**
  * Función para crear una linea de garantía de tipo FromGroup.
  */
  crearLinea() {
    return this.formBuilder.group({
      idGarantia: this.flagCrear ? '' : this.garantia.idGarantia,
      idLineaGarantia: '',
      Monto_Linea: [{ value: '', disabled: this.flagVer }],
      Tipo: [{ value: '', disabled: this.flagVer }],
      Estado: [{ value: 'ACTIVO', disabled: true }],
      nuevo: true
    });
  }

  /**
  * Función para agregar una linea creada al grupo de lineas existentes.
  */
  agregarLinea() {
    this.groupLineas.push(this.crearLinea());
  }

  /**
  * Función para actualizar una linea según el índice y el nro. de lineas que tiene la garantía.
  */
  actualizarLinea(index: number, linea: any) {
    this.groupLineas.at(index).patchValue({
      idGarantia: linea.idGarantia,
      idLineaGarantia: linea.idLineaGarantia,
      Monto_Linea: linea.Monto_Linea,
      Tipo: linea.Tipo,
      Estado: linea.Estado_Descripcion.toUpperCase(),
      Usuario: linea.Usuario,
      nuevo: linea.idLineaGarantia ? false : true
    });
  }

  /**
  * Función para quitar del listado una linea según el índice.
  */
  quitarLinea(index: any) {
    this.groupLineas.removeAt(index);
    this.lineasGarantiaTemp.splice(index, 1);
  }

  /**
  * Función para asignar uno o más lineas al grupo de lineas de garantía.
  */
  asignarLineas(lineasArr: any) {
    lineasArr.forEach((lineaElement: any, index: number) => {
      this.groupLineas.push(this.crearLinea());
      this.actualizarLinea(index, lineaElement);
    });
  }

  /**
  * Función para completar los montos de cobertura en el formulario según el valor del monto total.
  */
  actualizarMonto() {
    this.segundoFormGroup.patchValue({
      Monto_Cobertura_Disponible: this.segundoFormGroup.get('Monto_Cobertura_Maxima').value,
      Monto_Cobertura_Ejecutado: 0,
      Monto_Cobertura_Bloqueado: 0
    });
  }

  /**
  * Función para preparar el body de creación o actualización de la garantía.
  * @param accion Tipo de acción a realizar (ver enum ACCION_GARANTIA)
  */
   armarBodyGarantia(accion: number, indexLinea?: number) {
    let moneda = Number(this.primerFormGroup.get('Moneda').value);
    let fechaIGarantiaCreacion = this.primerFormGroup.get('Fecha_Inicio').value;
    let fechaFGarantiaCreacion = (this.primerFormGroup.get('Fecha_Fin').value != null) ? this.primerFormGroup.get('Fecha_Fin').value : null;

    if (accion == ACCION_GARANTIA.REGISTRO_GARANTIA) {

      this.agregarLinea();

      this.groupLineas.at(0).patchValue({
        idGarantia: '',
        idLineaGarantia: '',
        Monto_Linea: this.segundoFormGroup.get('Monto_Cobertura_Maxima').value,
        Tipo: this.segundoFormGroup.get('Tipo').value,
        Estado: 'A',
        Usuario: this.userActive.Usuario,
        nuevo: true
      });

      let boolMultiMoneda: boolean = this.primerFormGroup.get('Multiples_Moneda').value;

      this.formGarantia = this.formBuilder.group({
        Nombre_Garantia: this.primerFormGroup.get('Nombre_Garantia').value,
        Codigo_Garantia: this.primerFormGroup.get('Codigo_Garantia').value,
        Fecha_Inicio: this.datePipe.transform(fechaIGarantiaCreacion, 'yyyy-MM-dd'),
        Fecha_Fin: (fechaFGarantiaCreacion != null) ? this.datePipe.transform(fechaFGarantiaCreacion, 'yyyy-MM-dd') : null,
        lineas_garantia: this.groupLineas,
        Moneda: moneda,
        Multiples_Moneda: (boolMultiMoneda) ? 'A' : 'I',
        Usuario: this.userActive.Usuario
      });

    } else if (accion == ACCION_GARANTIA.MODIFICAR_DATOS_GARANTIA) {

      let boolMultiMoneda: boolean = this.primerFormGroup.get('Multiples_Moneda').value;

      this.formGarantia.patchValue({
        idGarantia: this.garantia.idGarantia,
        Nombre_Garantia: this.primerFormGroup.get('Nombre_Garantia').value,
        Codigo_Garantia: this.primerFormGroup.get('Codigo_Garantia').value,
        Monto_Cobertura_Maxima: this.garantia.Monto_Cobertura_Maxima,
        Monto_Cobertura_Disponible: this.garantia.Monto_Cobertura_Disponible,
        Monto_Cobertura_Ejecutado: this.garantia.Monto_Cobertura_Ejecutado,
        Monto_Cobertura_Bloqueado: this.garantia.Monto_Cobertura_Bloqueado,
        Moneda: moneda,
        Multiples_Moneda: (boolMultiMoneda) ? 'A' : 'I',
        Fecha_Inicio: this.datePipe.transform(fechaIGarantiaCreacion, 'yyyy-MM-dd'),
        Fecha_Fin: (fechaFGarantiaCreacion != null) ? this.datePipe.transform(fechaFGarantiaCreacion, 'yyyy-MM-dd') : null,
        Estado: this.primerFormGroup.get('Estado').value,
        Usuario: this.userActive.Usuario
      });

    } else if (accion == ACCION_GARANTIA.CREAR_LINEA_GARANTIA) {

      let arrayTotal = this.groupLineas.getRawValue();
      let arrayCreados = arrayTotal.filter(elemento => elemento.nuevo);
      this.arrLineasGarantiaTemp = this.formBuilder.array([]);

      arrayCreados.forEach(element => {
        let lineaGarantiaTemp = this.formBuilder.group({
          idGarantia: element.idGarantia,
          idLineaGarantia: element.idLineaGarantia,
          Monto_Linea: element.Monto_Linea,
          Tipo: element.Tipo,
          Usuario: this.userActive.Usuario
        });
        this.arrLineasGarantiaTemp.push(lineaGarantiaTemp);
      });

      this.formGarantia = this.formBuilder.group({
        idGarantia: this.garantia.idGarantia,
        Usuario: this.userActive.Usuario,
        lineas_garantia: this.arrLineasGarantiaTemp,
      });

    }
  }

  /**
  * Función para registrar una garantía.
  */
  crearGarantia() {
    this.armarBodyGarantia(ACCION_GARANTIA.REGISTRO_GARANTIA);

    Swal.fire({
      text: 'Confirmar la creación de la nueva garantía',
      type: 'info',
      showCancelButton: true,
      cancelButtonText: 'No, cancelar',
      showConfirmButton: true,
      confirmButtonText: 'Si, crear garantía',
      allowOutsideClick: false,
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {

      if (result.value) {

        Swal.fire({
          title: 'Espere',
          text: 'Guardando los cambios...',
          type: 'info',
          allowOutsideClick: false,
          heightAuto: false
        });
        Swal.showLoading();

        this.riesgoService.registrarGarantia(this.formGarantia.getRawValue()).subscribe(
          (resGarantia: any) => {
            let idGarantia = resGarantia.message.idGarantia;
            Swal.fire({
              title: 'Éxito',
              text: '¡La garantía N° '.concat(idGarantia, ' ha sido registrada correctamente!'),
              type: 'success',
              allowOutsideClick: false,
              heightAuto: false
            });

            this.loginService.clickGuard = true;
            this.router.navigate(['/fondo/concentracion/garantias/listado']);
          },
          (err: HttpErrorResponse) => {
            this.loadingLineas = false;
            this.loadingLineasError = true;
            this.lineasGarantia = [];
            Swal.fire({
              title: 'Error',
              html: this.alertService.createTextError(err, 'Hubo un error a la hora de crear la garantía. <br/>'),
              type: "error",
              allowOutsideClick: true,
              heightAuto: false
            });
          }
        );

      }

    });
  }

  /**
  * Función para editar un aspecto/parte de la garantía (datos generales, linea de garantía).
  */
  editarGarantia(nroForm: number, indexLinea?: number) {
    this.armarBodyGarantia(nroForm, indexLinea);

    this.armarTextSwal(nroForm);

    Swal.fire({
      text: this.textQuestionSwal,
      type: 'info',
      showCancelButton: true,
      cancelButtonText: 'No, cancelar',
      showConfirmButton: true,
      confirmButtonText: 'Si, guardar cambios',
      allowOutsideClick: false,
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {

      if (result.value) {

        Swal.fire({
          title: 'Espere',
          text: 'Guardando los cambios...',
          type: 'info',
          allowOutsideClick: false,
          heightAuto: false
        });
        Swal.showLoading();

        if (nroForm == ACCION_GARANTIA.MODIFICAR_DATOS_GARANTIA) {

          this.riesgoService.actualizarGarantia(nroForm, this.formGarantia.getRawValue(), this.garantia.idGarantia).subscribe(
            () => {
              Swal.fire({
                title: 'Éxito',
                text: '¡Los datos de la garantía N° '.concat(this.garantia.idGarantia.toString(), ' han sido actualizados correctamente!'),
                type: 'success',
                allowOutsideClick: false,
                heightAuto: false
              });

              this.loginService.clickGuard = true;
              this.router.navigate(['/fondo/concentracion/garantias/listado']);
            },
            (err: HttpErrorResponse) => {
              this.loadingLineas = false;
              this.loadingLineasError = true;
              this.lineasGarantia = [];
              Swal.fire({
                title: 'Error',
                html: this.alertService.createTextError(err, 'Hubo un error a la hora de actualizar los datos generales de la garantía. <br/>'),
                type: "error",
                allowOutsideClick: true,
                heightAuto: false
              });
            }
          );

        } else if (nroForm == ACCION_GARANTIA.CREAR_LINEA_GARANTIA) {
          if (this.arrLineasGarantiaTemp.length > 0) {
            this.textConfirmSwal = '¡Las lineas para la garantía N° '.concat(this.garantia.idGarantia.toString(), ' han sido registradas correctamente!');
            this.textErrorSwal = "Hubo un error a la hora de registrar las lineas de la garantía.";
          } else {
            this.textErrorSwal = '¡La linea para la garantía N° '.concat(this.garantia.idGarantia.toString(), ' ha sido registrada correctamente!');
            this.textErrorSwal = "Hubo un error a la hora de registrar la linea de la garantía.";
          }

          this.riesgoService.crearListLineaGarantia(this.formGarantia.getRawValue()).subscribe(
            () => {
              Swal.fire({
                title: 'Éxito',
                text: this.textConfirmSwal,
                type: 'success',
                allowOutsideClick: false,
                heightAuto: false
              });

              this.loginService.clickGuard = true;
              this.router.navigate(['/fondo/concentracion/garantias/listado']);
            },
            (err: HttpErrorResponse) => {
              Swal.fire({
                title: 'Error',
                html: this.alertService.createTextError(err, this.textErrorSwal.concat('<br>')),
                type: "error",
                allowOutsideClick: true,
                heightAuto: false
              });
            }
          );
        }

      }

    });
  }

  armarTextSwal(nroForm: number) {
    if (nroForm == ACCION_GARANTIA.MODIFICAR_DATOS_GARANTIA) {
      this.textQuestionSwal = 'Confirmar la actualización de los datos generales de la garantia';
    } else if (nroForm == ACCION_GARANTIA.CREAR_LINEA_GARANTIA) {
      if (this.arrLineasGarantiaTemp.length > 0) {
        this.textQuestionSwal = 'Confirmar la creación de las lineas de la garantia';
      } else {
        this.textQuestionSwal = 'Confirmar la creación de la linea de la garantia';
      }
    }
  }

}
